import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, Select } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { PreapprovalPeriodType } from '~/models/service-billing/model';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
const preapprovalPeriodOptionValues = [
    PreapprovalPeriodType.Weekly,
    PreapprovalPeriodType.BiWeekly,
    PreapprovalPeriodType.Monthly,
    PreapprovalPeriodType.Quarterly,
    PreapprovalPeriodType.Yearly,
    PreapprovalPeriodType.NoTimeLimit
];
const preapprovalPeriodLabelKey = {
    [PreapprovalPeriodType.Weekly]: 'weekly',
    [PreapprovalPeriodType.BiWeekly]: 'biWeekly',
    [PreapprovalPeriodType.Monthly]: 'monthly',
    [PreapprovalPeriodType.Quarterly]: 'quarterly',
    [PreapprovalPeriodType.Yearly]: 'yearly',
    [PreapprovalPeriodType.NoTimeLimit]: 'noTimeLimit'
};
export default function PreapprovalPeriodSelect() {
    const { control } = useFormContext();
    const { t: preapprovalTexts } = useLocaleKeys('billing.preapproval');
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "preapprovalPeriod",
        render: (renderProps)=>{
            const _connectControllerToTextField = connectControllerToTextField(renderProps), { onChange } = _connectControllerToTextField, rest = _object_without_properties(_connectControllerToTextField, [
                "onChange"
            ]);
            return /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({}, rest), {
                label: preapprovalTexts.periodLabel(),
                testId: "preapproval-period-select",
                onChange: onChange,
                children: preapprovalPeriodOptionValues.map((value)=>/*#__PURE__*/ _jsx(MenuItem, {
                        value: value,
                        testId: "preapproval-period-opt-".concat(value),
                        children: preapprovalTexts.periodOptions[preapprovalPeriodLabelKey[value]]()
                    }, value))
            }));
        }
    });
}
